<template>
  <main>
    <Header :loginSource="1"></Header>
    <section class="logo_search_container">
<!--      <img src="/static/images/banner_bg.jpg" alt="芽乐科技">-->
<!--      <img src="/static/images/flink_on_k8s/flink_on_k8s_kcdg.jpg" alt="芽乐科技">-->


      <el-carousel style="width: 1000px; height: 500px; margin: auto;" trigger="click" height="500px" :interval="interval">
        <el-carousel-item>
          <img style="width: 1000px; height: 500px; margin: auto;" src="/static/images/banner_bg.jpg" alt="芽乐科技">
        </el-carousel-item>
        <el-carousel-item>
          <img style="width: 1000px; height: 500px; margin: auto;" src="/static/images/banner_bg2.png" alt="芽乐科技">
        </el-carousel-item>
        <el-carousel-item>
          <img style="width: 1000px; height: 500px; margin: auto;" src="/static/images/banner_bg3.png" alt="芽乐科技">
        </el-carousel-item>
      </el-carousel>

    </section>
    <section class="merchant_container">
<!--      <img class="wxgroup_img" src="/static/images/wxgroup.png" >-->
      <div class="merchant_wrapper">
        <div class="order_title">课程列表</div>
        <hr>
        <div v-for="(item, index) in courses" :key="index" class="merchant_block">
          <div class="merchant_content">
            <img class="storefront_image" :src="item.coverPic"  @click="gotoCourse(item.no)">
            <div class="merchant_desc">
              <div style="display: flex; flex-direction: row">
                <div v-if="item.realPrice < 90000" class="merchant_name" @click="gotoCourse(item.no)">{{item.name}}</div>
                <div v-else class="merchant_name" @click="gotoCourse(item.no)">{{item.name}}（更新中）</div>
                <div style="margin-left: 12px; font-size: 14px; color: #999; font-weight: normal;" v-if="item.realPrice < 90000 && item.statistics.buyTimes >= 49">
                  <span><i class="el-icon-shopping-cart-2"></i> {{item.statistics.buyTimes}}</span>&nbsp;
                  <span><i class="el-icon-video-play"></i> {{item.statistics.viewTimes}}</span>
                </div>
              </div>

              <div class="merchant_item">{{item.shortDesc}}</div>
              <div v-if="item.realPrice > 99" class="merchant_higher_price">课程原价：￥{{item.originalPrice}}</div>
<!--              <div v-if="item.realPrice < 90000" class="merchant_lower_price">限时优惠：￥{{item.realPrice}}</div>-->
              <div v-if="item.realPrice < 90000" class="merchant_lower_price">{{item.realPrice < 100 ? '内部专享' : '限时优惠'}}：￥{{item.realPrice}}</div>
              <div v-else class="merchant_lower_price">限时优惠：价格待定</div>
            </div>
            <el-button class="search_button" type="primary" icon="el-icon-video-camera" @click="gotoCourse(item.no)">{{item.realPrice < 90000 ? '开始学习' : '抢先试看'}}</el-button>
          </div>
          <hr>
        </div>

      </div>
    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapState} from 'vuex'
import {
  reqFindAllCourse
} from '@/api'

export default {
  name: 'Index',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      interval: 10000
    }
  },

  mounted () {
    this.getCourses()
  },

  methods: {
    async getCourses () {
      if (this.courses.length)
        return

      const result = await reqFindAllCourse()
      if (result.code === 0) {
        const courses = result.data
        this.$store.dispatch('setCourses', {courses})
      }
    },

    gotoCourse (no) {
      // this.$store.dispatch('setMerchant', {merchant: this.merchants[Number.parseInt(index)]})
      // console.log((no))
      // this.$router.push('/course')

      this.$router.push({
        path: '/course',
        query: {no: no}
      })
    },

  },

  computed: {
    ...mapState(['courses']),
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }

  .logo_search_container > img {
    width: 1000px;
    /*width: 65vw;*/
    height: 500px;
    margin: auto;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background: #eee;*/
  }

  .merchant_wrapper {
    /*width: 960px;*/
    width: 1000px;
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 320px;
    height: 260px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_name {
    cursor: pointer;
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .merchant_item {
    font-size: 14px;
    color: #333;
  }

  .merchant_higher_price {
    font-size: 16px;
    color: #999;
    text-decoration:line-through;
  }

  .merchant_lower_price {
    font-size: 18px;
    color: #CC0033;
    font-weight: bold;
  }

  .search_button {
    margin-left: 30px;
    height: 40px;
  }

  .wxgroup_img {
    position: fixed;
    top: 100px;
    right: 50px;
    width: 170px;
    height: 210px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index/Index.vue